<template>
	<div class="notice_popup human int">
		<div class="close">
			<img src="/images/mem/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<div class="tit" style="margin-left: 9px; font-size: 20px">이력서 파일이 성공적으로 업로드되었습니다.</div>
		<div class="member" style="line-height: 30px;">
			전담 매니저가 내용 검토 후<br/>
			사이트 양식에 맞춰 등록을 도와드릴 예정입니다.<br/>
			등록 완료 시, 개별 연락드리겠습니다.
		</div>
		<div class="select-btn">
			<!-- <div class="btn" @click="$emit('close')">취소</div> -->
			<div class="btn blue" @click="$emit('close', false)">확인</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {}
	},
    methods: {
	}
}
</script>